module.exports = __webpack_public_path__ + "static/media/0.9bba1d73.png";